export function isPointInPolygon(point: [number, number], polygon: [number, number][]): boolean {
  const [x, y] = point
  let inside = false
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const [xi, yi] = polygon[i]
    const [xj, yj] = polygon[j]
    const intersects = yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
    if (intersects) inside = !inside
  }
  return inside
}

export function sampleColor(palette: string[], t: number): string {
  const clamped = Math.min(1, Math.max(0, t))
  const scaled = clamped * (palette.length - 1)
  const index = Math.min(palette.length - 2, Math.floor(scaled))
  const local = scaled - index
  const from = hexToRgb(palette[index])
  const to = hexToRgb(palette[index + 1])
  const mix = (a: number, b: number) => Math.round(a + (b - a) * local)
  return `rgb(${mix(from[0], to[0])}, ${mix(from[1], to[1])}, ${mix(from[2], to[2])})`
}

function hexToRgb(hex: string): [number, number, number] {
  const value = parseInt(hex.replace('#', ''), 16)
  return [(value >> 16) & 255, (value >> 8) & 255, value & 255]
}
